export enum ToothView {
	BUCCAL = 'BUCCAL', //LOWER OR UPPER TOOTH FROM FRONT
	INCISAL = 'INCISAL', //LOWER OR UPPER TOOTH FROM TOP
	PALATAL = 'PALATAL', //UPPER TOOTH FROM BACK
	LINGUAL = 'LINGUAL', //LOWER TOOTH FROM BACK
}
